// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error404[data-v-d439cee2]{width:100%;height:100%;line-height:70vh;text-align:center;color:red;font-size:120px;font-weight:900;font-style:oblique}.error404 p[data-v-d439cee2]:last-child{position:relative;top:-550px;font-size:20px}", ""]);
// Exports
module.exports = exports;
